import React, {useEffect, useState} from 'react';
import {
    authAPI,
} from "../services/AuthService";
import {Navigation} from "../components/ClientScreen/Navigation";
import {Button, FloatButton, Menu, MenuProps, Modal, Segmented, Space, Spin} from "antd";
import {TaskCard} from "../components/ClientScreen/TaskCard";
import {Navigate} from "react-router-dom";
import {taskAPI} from "../services/TaskService";
import {TaskModel} from "../models/TaskModel";
import {EditOutlined, FilterOutlined, LogoutOutlined, RedoOutlined} from "@ant-design/icons";
import {FilterModal} from "../components/ClientScreen/FilterModal";
import {host, port, secure} from "../config/config";


export const UserTasksScreen: React.FC = () => {
    const [redirectToLogin, setRedirectToLogin] = useState<boolean>(false);
    const [currentMenuItem, setCurrentMenuItem] = useState('created');
    const [currentTopMenuItem, setCurrentTopMenuItem] = useState('mail');
    const [getMyTasksRequest, {
        data: dataGetMyTasksRequest,
        isLoading: isGetMyTasksIsLoading,
        isError: isErrorGetMyTasks,
    }] = taskAPI.useGetMyTasksMutation();
    const [redirectToCreateTask, setRedirectToCreateTask] = useState<boolean>(false);
    // Return to login if reject token verify
    const [verifyTokenRequest, {status: statusVerifyTokenRequest}] = authAPI.useVerifyTokenMutation();
    useEffect(() => {
        verifyTokenRequest();
    }, [])
    useEffect(() => {
        if (statusVerifyTokenRequest === 'rejected') localStorage.clear();
        if (statusVerifyTokenRequest === 'rejected') {
            localStorage.clear()
            setRedirectToLogin(true)
        }
    }, [statusVerifyTokenRequest])
    // -----
    const [filterModalVisible, setFilterModalVisible] = useState<boolean>(false);
    const [filterByFilial, setFilterByFilial] = useState<string | null>(null);
    const [filterByObject, setFilterByObject] = useState<string | null>(null);
    const [reportIsLoading, setReportIsLoading] = useState(false);
    const topNavigationItems: MenuProps['items'] = [
        {
            label: 'Фильтр',
            key: 'filter',
            icon: <FilterOutlined/>,
        },
        {
            label: 'Обновить',
            key: 'refresh',
            icon: <RedoOutlined/>,
        },
        {
            label: 'Выйти',
            key: 'logout',
            icon: <LogoutOutlined/>,
        },
    ];
    const tonTopNavigationClick: MenuProps['onClick'] = (e) => {
        if (e.key === "logout") {
            localStorage.clear();
            setRedirectToLogin(true);
        } else if (e.key === "refresh") {
            getMyTasksRequest();
        } else if (e.key === "filter") {
            setFilterModalVisible(true);
        }
        setCurrentTopMenuItem(e.key);
    };
    useEffect(() => {
        getMyTasksRequest();
    }, [])
    const exportHandler = () => {
        setReportIsLoading(true)
        try {
            let myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            // @ts-ignore
            fetch(`${secure}://${host}${port}/tasks/allExcel`, requestOptions)
                .then(response => {
                    if (response.ok && (response.status === 200)) {
                        return response.blob();
                    }
                })
                .then(data => {
                    if (data) {
                        // @ts-ignore
                        const url = window.URL.createObjectURL(data);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "Заявки.xls");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    setReportIsLoading(false)
                });
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <>
            {redirectToLogin && <Navigate to="/login" replace={false}/>}
            {redirectToCreateTask && <Navigate to="/my/createTask" replace={false}/>}
            {filterModalVisible &&
                <FilterModal filterByFilial={filterByFilial} filterByObject={filterByObject}
                             tasks={dataGetMyTasksRequest ?? []} setFilterByFilial={setFilterByFilial}
                             setFilterByObject={setFilterByObject}
                             visible={filterModalVisible} setVisible={setFilterModalVisible}/>}
            <Menu className="centeredItemsTop" style={{marginBottom: 5, display: 'flex', justifyContent: 'center'}}
                  defaultValue={'filter'} onClick={tonTopNavigationClick}
                  selectedKeys={[currentTopMenuItem]} mode="horizontal" items={topNavigationItems}/>
            <div className="centeredItemsTop" style={{marginBottom: 5}}>
                {/*@ts-ignore*/}
                <Segmented onChange={e => {
                    // @ts-ignore
                    setCurrentMenuItem(e)
                }} size={'middle'} block style={{width: '100%'}} options={[
                    {
                        label: `(${dataGetMyTasksRequest?.filter((t: TaskModel) => {
                            if (t.status === 'created')
                                if (filterByFilial || filterByObject) {
                                    if ((t.object === filterByObject || filterByObject === null) && (t.filial === filterByFilial || filterByFilial === null))
                                        return t
                                } else return t
                        }).length ?? ""})Новые`,
                        value: 'created'
                    },
                    {
                        label: `(${dataGetMyTasksRequest?.filter((t: TaskModel) => {
                            if (t.status === 'inProcess')
                                if (filterByFilial || filterByObject) {
                                    if ((t.object === filterByObject || filterByObject === null) && (t.filial === filterByFilial || filterByFilial === null))
                                        return t
                                } else return t
                        }).length ?? ""})В работе`,
                        value: 'inProcess'
                    },
                    {
                        label: `(${dataGetMyTasksRequest?.filter((t: TaskModel) => {
                            if (t.status === 'completed')
                                if (filterByFilial || filterByObject) {
                                    if ((t.object === filterByObject || filterByObject === null) && (t.filial === filterByFilial || filterByFilial === null))
                                        return t
                                } else return t
                        }).length ?? ""})Выполненые`,
                        value: 'completed'
                    }]}/>
            </div>
            <Space direction="vertical" size="middle"
                   style={{display: 'flex'}}>
                {dataGetMyTasksRequest && dataGetMyTasksRequest.map((task: TaskModel) => {
                    if (task.status === currentMenuItem)
                        if (filterByFilial || filterByObject) {
                            if ((task.object === filterByObject || filterByObject === null) && (task.filial === filterByFilial || filterByFilial === null))
                                return (
                                    <TaskCard id={task.id} equipmentCode={task.equipmentCode ?? ''}
                                              equipmentName={task.equipmentName ?? ''} date={task.date}
                                              status={task.status} object={task.object ?? ''}
                                              filial={task.filial ?? ''}/>
                                )
                        } else
                            return (
                                <TaskCard id={task.id} equipmentCode={task.equipmentCode ?? ''}
                                          equipmentName={task.equipmentName ?? ''} date={task.date}
                                          status={task.status} object={task.object ?? ''} filial={task.filial ?? ''}/>
                            )
                })}
                {isGetMyTasksIsLoading &&
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '40vh'}}><Spin size={'large'}/>
                    </div>}
            </Space>
            <FloatButton.Group shape="circle" style={{right: 24}}>
                <FloatButton onClick={() => setRedirectToCreateTask(true)} type="primary" icon={<EditOutlined/>}/>
            </FloatButton.Group>
        </>
    );
};